import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, BookOpen, ChevronDown } from 'lucide-react';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const menuItems = [
    { label: 'صفحه اصلی', path: '/' },
    {
      label: 'درباره نشریه',
      submenu: [
        { label: 'درباره ما', path: '/about' },
        { label: 'هیئت تحریریه', path: '/editorial-board' },
        { label: 'مشاوران علمی', path: '/scientific-advisors' },
        { label: 'سیاست‌های نشریه', path: '/policies' },
        { label: 'اهداف و دامنه', path: '/scope-objectives' },
        { label: 'تاریخچه', path: '/history' },
      ]
    },
    {
      label: 'شماره‌ها و مقالات',
      submenu: [
        { label: 'آخرین شماره', path: '/issues' },
        { label: 'تمام مقالات', path: '/articles' },
        { label: 'آرشیو', path: '/archive' },
        { label: 'جستجو پیشرفته', path: '/search' },
        { label: 'مقالات منتخب', path: '/featured-articles' },
      ]
    },
    {
      label: 'برای نویسندگان',
      submenu: [
        { label: 'راهنمای نویسندگان', path: '/author-guide' },
        { label: 'نحوه ارسال مقاله', path: '/submission-process' },
        { label: 'قالب و الگو', path: '/templates' },
        { label: 'بررسی اخلاقی', path: '/ethics-review' },
        { label: 'شرایط انتشار', path: '/publication-terms' },
      ]
    },
    { label: 'ارسال مقاله', path: '/submit', highlight: true },
    {
      label: 'برای خوانندگان',
      submenu: [
        { label: 'دسترسی آزاد', path: '/open-access' },
        { label: 'اشتراک خبرنامه', path: '/newsletter' },
        { label: 'RSS Feed', path: '/rss' },
        { label: 'نشریات مرتبط', path: '/related-journals' },
      ]
    },
    {
      label: 'اطلاعات',
      submenu: [
        { label: 'سوالات متداول', path: '/faq' },
        { label: 'تماس با ما', path: '/contact' },
        { label: 'نقشه سایت', path: '/sitemap' },
        { label: 'شکایات و پیشنهادات', path: '/feedback' },
        { label: 'حریم خصوصی', path: '/privacy' },
      ]
    },
  ];

  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center gap-3 group flex-shrink-0">
            <div className="w-12 h-12 bg-gradient-to-br from-blue-700 to-blue-900 rounded-lg flex items-center justify-center shadow-md group-hover:shadow-lg transition">
              <BookOpen className="w-6 h-6 text-white" />
            </div>
            <div className="flex flex-col">
              <span className="text-lg font-bold text-gray-900">نشریه مجری</span>
              <span className="text-xs text-gray-500">سازمان مجری</span>
            </div>
          </Link>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 text-gray-700"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          <div className={`${isOpen ? 'block' : 'hidden'} md:flex absolute md:static top-20 left-0 right-0 md:top-auto bg-white md:bg-transparent shadow-lg md:shadow-none border-t md:border-t-0 border-gray-200 md:border-0`}>
            <div className="flex flex-col md:flex-row gap-0 md:gap-0 p-0 md:p-0 w-full md:w-auto">
              {menuItems.map((item, idx) => (
                <div key={idx} className="relative group w-full md:w-auto">
                  {item.submenu ? (
                    <button
                      onClick={() => setOpenDropdown(openDropdown === idx ? null : idx)}
                      className="px-4 py-3 md:py-2 text-gray-700 hover:text-blue-700 hover:bg-blue-50 md:hover:bg-transparent transition font-medium flex items-center justify-between md:justify-start gap-2 w-full md:w-auto"
                    >
                      {item.label}
                      <ChevronDown size={16} className={`transition md:hidden ${openDropdown === idx ? 'rotate-180' : ''}`} />
                    </button>
                  ) : (
                    <Link
                      to={item.path}
                      className={`px-4 py-3 md:py-2 transition font-medium block ${
                        item.highlight
                          ? 'text-white bg-blue-700 hover:bg-blue-800 md:rounded-lg'
                          : 'text-gray-700 hover:text-blue-700 hover:bg-blue-50 md:hover:bg-transparent'
                      }`}
                    >
                      {item.label}
                    </Link>
                  )}

                  {/* Mobile Dropdown Menu */}
                  {item.submenu && (
                    <div className={`${
                      openDropdown === idx ? 'block' : 'hidden'
                    } md:hidden bg-gray-100 border-t border-gray-300`}>
                      {item.submenu.map((subitem, subidx) => (
                        <Link
                          key={subidx}
                          to={subitem.path}
                          className="block px-8 py-2 text-gray-700 hover:text-blue-700 hover:bg-blue-50 transition text-sm"
                          onClick={() => setIsOpen(false)}
                        >
                          {subitem.label}
                        </Link>
                      ))}
                    </div>
                  )}

                  {/* Desktop Dropdown */}
                  {item.submenu && (
                    <div className="hidden group-hover:block absolute left-0 top-full mt-0 w-56 bg-white rounded-lg shadow-xl border border-gray-200 z-50">
                      {item.submenu.map((subitem, subidx) => (
                        <Link
                          key={subidx}
                          to={subitem.path}
                          className="block px-4 py-3 text-gray-700 hover:text-blue-700 hover:bg-blue-50 transition text-sm first:rounded-t-lg last:rounded-b-lg border-b border-gray-100 last:border-b-0"
                        >
                          {subitem.label}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
